/* eslint-disable @typescript-eslint/naming-convention */
import { AppConfig, AuthConfig, UserData } from "./models/application/appConfig.model";
declare const window: any;

export enum Environments {
  Test,
  Acceptance,
  Production,
  UAT
}

export class Config {
  // Constants used throughout the App
  // eslint-disable-next-line
  public static readonly CONSTANTS = {
    appName: 'FDC',
    autoSaveTime: 0,
    maxNumValue: 999999999999999,
    searchUserDelay: 500,
    dashboardPageSize: 100,
    changeDetectionTime: 500,
    exportCSVFileLength: 150,

    // Text Area
    textAreaRows: 4,
    textAreaMaxLength: 500,

    // String Constants
    routeQuestionEditor: "/builder/question-editor",
    routeBuilder: '/builder/editor',
    routePreview: '/builder/preview',
    routeDashboard: '/dashboard',
    routeQuestionLibrary: "/question-library",
    bulkUpload: "/upload-questions",

    otherKeySuffix: 'Other',
    otherDescription: 'OtherDescription',
    otherMaxLength: 35,
    commentKeySuffix: '_CMCT',
    commentKeyTitle: '_CMTT',
    commentKeyId: '_CMID',
    commentMaxLength: 500,
    commentTitle: '',
    commentSuffix: '_comment',

    optionKeyDefaultPrefix: 'option',

    // Error/Success messages
    successSaveLocalQuestion: 'Question added to local library',
    errorSaveLocalQuestion: 'Error adding question to local library. Duplicate name?',
    errorRepeatedValue: "This value exists. Please enter other value",
    succesfullDeleteMessgae: "Undo Question Successfully",
    succesfullyClonedMessage: "Question cloned successfully",
    succesfullQuestionRetrieveMessage: "Question Retrieved Successfully",
    succesfullQuestionJSONUpdateMessage: "Question Updated from Edited JSON",

    // Permissions
    FB_Dev_Forms: "FB_Dev_Forms",
    FB_Design_Forms: "FB_Design_Forms",
    FB_Approve_Forms: "FB_Approve_Forms",
    FB_Admin_Forms: "FB_Admin_Forms",
  };

  // Global variables used throughout the App
  // eslint-disable-next-line
  public static GLOBALS = {
    searchUserDelay: 500,
    dashboardPageSize: 100,

    // Experimental features: Please create a comment for options that are true for Beta (default: all false)
    isQuestionConditionalActive: false,
    isFormListRetrievedFromAPI: true,   // Beta: true
    isPreviewOpenFromModal: true,       // Beta: true
    isDashboardFilterEnabled: true,
    isDashboardDataExportEnabled: false,
    isPendingSaveIndicatorEnabled: false,
    isFormIdEnabled: false,
    isQuestionSaveButtonEnabled: false,
    isBulkQustionUpload: true,
    isQuestionDroppingAreaEnabled: false,
    isPreviewFormDetailsEnabled: false,
  };

  // Global level FEATURES constants. Should be ok in UPPER CASE
  // eslint-disable-next-line
  public static FEATURES = new Map<string, boolean>([
    ["isQuestionEditorEnabled", false],
    ["isQuestionDialogEditor", false],
    ["isQuestionToFormDropEnabled", false],
    ["isHotKeysEnabled", false],
    ["isMultipleSelectionEnabled", false],
    ["isSectionNestingActive", false],
    ["isUndoRedoButtonEnabled", false],
    ["isLocalQuestionLibraryEnabled", false],
    ["isPreviewShowJSON", false],
    ["isContextMenuEnabled", false],
    ["isQuestionLibraryPage", true],
    ["isMultiScroll", true],
    ["isQuestionCommentEnabled", false],
    ["isFieldKeyVisible", true],
    ["isFlatModelSubmitEnabled", true],
  ]);

  // Validation static previous value
  public static previousValue: string | undefined = undefined;

  public static get app(): AppConfig {
    return window.config;
  }
  public static get auth(): AuthConfig {
    return window.auth;
  }

  public static get projectApiUrl(): string {
    return Config.app?.secureapi ? Config.app?.projectapiKongUrl : Config.app?.projectApiUrl;
  }
  public static get authorizationApiUrl(): string {
    return Config.app?.secureapi ? Config.app?.authorizationApiKongUrl : Config.app?.authorizationApiUrl;
  }


  // public static user: UserData = { name: '', iNumber: '', fullName };
  public static get user(): UserData {
    const session = JSON.parse(localStorage.getItem('okta-token-storage') || "{}");
    const userFullName = session!.idToken?.claims.name || "";
    const email = session!.idToken?.claims.preferred_username || "";
    const username = email?.toUpperCase();
    const userINumber = email?.split("@")[0];
    return { name: username, iNumber: userINumber, fullName: userFullName };
  }
}
